import {TIKTOK_URL} from '@cohort/shared/apps/tiktok/common';
import type {TikTokKeywordInDescriptionTriggerStruct} from '@cohort/shared/apps/tiktok/triggers/keywordInDescription';
import type {ActionCtaComponentProps} from '@cohort/wallet/apps/TriggerIntegration';
import OpenCtaWithRefresh from '@cohort/wallet/components/challenges/OpenCtaWithRefresh';
import {useTranslation} from 'react-i18next';

const TiktokKeywordInDescriptionTriggerActionCtaComponent: React.FC<
  ActionCtaComponentProps<TikTokKeywordInDescriptionTriggerStruct>
> = ({trackingMetadata, stepId, processStepVerification}) => {
  const {t} = useTranslation('app-tiktok', {
    keyPrefix: 'triggers.keyword-in-description',
  });

  return (
    <OpenCtaWithRefresh
      url={TIKTOK_URL}
      stepId={stepId}
      processStepVerification={processStepVerification}
      trackingMetadata={trackingMetadata}
      ctaTitle={t('ctaTitle')}
      refreshCtaTitle={t('refreshTitle')}
    />
  );
};

export default TiktokKeywordInDescriptionTriggerActionCtaComponent;
